import Marquee from "react-fast-marquee";
import { useLanguage } from "../context/LanguageContext";

export const MarqueeSection = () => {
  const { lang, t } = useLanguage();

  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#2A2A2A] bg-[#0D0D0D] py-8"
    >
      <Marquee speed={30} gradient={false} key={lang}>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span className="whitespace-nowrap font-cormorant text-4xl italic text-[#8A9199] md:text-6xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#C5A059]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
